import React from "react";

export const ThunderstormsIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="04" fill="#3F4447">
                <g transform="translate(4.000000, 10.000000)">
                    <path
                        d="M0.5,29.6122449 C0.5,37.8398521 7.26573556,44.5 15.6,44.5 L59.8,44.5 C66.2564963,44.5 71.5,39.3383277 71.5,32.9591837 C71.5,26.5800397 66.2564963,21.4183673 59.8,21.4183673 C58.7705447,21.4183673 57.7573261,21.5498735 56.7792921,21.8070512 C55.9781011,22.0177273 55.4993942,22.8380078 55.7100704,23.6391988 C55.9207465,24.4403898 56.741027,24.9190967 57.542218,24.7084205 C58.2717181,24.5165958 59.028541,24.4183673 59.8,24.4183673 C64.6101126,24.4183673 68.5,28.2475482 68.5,32.9591837 C68.5,37.6708191 64.6101126,41.5 59.8,41.5 L15.6,41.5 C8.91211925,41.5 3.5,36.1723436 3.5,29.6122449 C3.5,23.3011065 8.52355909,18.0914806 14.9178361,17.7430245 C15.6535009,17.7029345 16.2511413,17.1345121 16.328025,16.4017783 C17.0934185,9.1072567 23.3707983,3.5 30.9,3.5 C36.2675746,3.5 41.1207257,6.35958347 43.6935633,10.8772644 C44.1035334,11.5971366 45.0194516,11.8483618 45.7393238,11.4383917 C46.459196,11.0284216 46.7104213,10.1125034 46.3004511,9.39263118 C43.1973844,3.94391348 37.3525357,0.5 30.9,0.5 C22.2638241,0.5 14.9814981,6.64434846 13.5172969,14.8649681 C6.14080192,15.8675997 0.5,22.1099533 0.5,29.6122449 Z"
                        fillRule="nonzero"
                    />
                    <rect
                        transform="translate(36.000000, 54.000000) rotate(45.000000) translate(-36.000000, -54.000000) "
                        x="34.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(26.000000, 54.000000) rotate(45.000000) translate(-26.000000, -54.000000) "
                        x="24.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(56.000000, 54.000000) rotate(45.000000) translate(-56.000000, -54.000000) "
                        x="54.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(46.000000, 54.000000) rotate(45.000000) translate(-46.000000, -54.000000) "
                        x="44.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <rect
                        transform="translate(16.000000, 54.000000) rotate(45.000000) translate(-16.000000, -54.000000) "
                        x="14.5"
                        y="49"
                        width="3"
                        height="10"
                        rx="1.5"
                    />
                    <path
                        d="M59.9953249,14.1898469 C61.3043768,14.1857669 61.9901744,15.7431257 61.1033463,16.7060221 L44.2396781,35.0161826 C43.0620523,36.29482 41.0163292,34.8816491 41.7954264,33.3277109 L47.569975,21.8101604 L40,21.8101604 C38.6895256,21.8101604 38.0091585,20.2477641 38.9018494,19.2883653 L55.9388864,0.978204885 C57.1125774,-0.283192231 59.1392221,1.10585741 58.3861934,2.6555738 L52.7705886,14.2123645 L59.9953249,14.1898469 Z M56.5693938,17.2005392 L50.3750455,17.2198454 C49.2653563,17.223304 48.5362229,16.0623799 49.021214,15.0642789 L51.3069495,10.3602857 L43.4446028,18.8101604 L50,18.8101604 C51.1157908,18.8101604 51.8409948,19.9850029 51.3409054,20.9824495 L49.2555887,25.1416908 L56.5693938,17.2005392 Z"
                        fillRule="nonzero"
                    />
                </g>
            </g>
        </g>
    </svg>
);
